<template>
  <el-dialog
    id="dialogServer"
    title="Изменение настроек даты и времени на камере ONVIF"
    :visible="visible"
    v-on="$listeners"
  >
    <el-form id="formDialog" label-width="150px" style="width: 500px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Дата и время" prop="set_camera_onvif_date">
            <el-date-picker
            v-model="datetime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="Часовой пояс" prop="timezone">
            <el-input-number
              :disabled="!$can('update', 'cameras')"
              id="timezone"
              v-model="timezone"
              :min="-12"
              :max="12"
              size="small"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="onClose">Отменить</el-button>
      <el-button
        id="submitServer"
        :loading="requestLoading"
        type="primary"
        @click="onSave"
      >
        Изменить
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "CameraOnvifDatetimeEdit",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id_camera: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      requestLoading: false,
      timezone: 7,
      datetime: new Date(),
    };
  },
  methods: {
    ...mapActions("cameras", {
      setDatetime: "UPDATE_CAMERA_ONVIF_DATETIME",
    }),
    onSave() {
      this.requestLoading = true;
      this.setDatetime({
          id: this.id_camera,
          hour: this.datetime.getHours(),
          minute: this.datetime.getMinutes(),
          second: this.datetime.getSeconds(),
          year: this.datetime.getFullYear(),
          month: this.datetime.getMonth() + 1,
          day: this.datetime.getDate(),
          timezone: this.timezone,
        }).then(() => {
        this.$message.success("Информация обновлена");
        this.$emit("update:visible", false);
      })
        .catch((e) => {
        this.$message({
          type: "error",
          message: e.response.data.error || "Неизвестная ошибка",
        });
      })
      .finally(() => {
        this.requestLoading = false;
      });
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
